<div class="container mt-card">
    <div class="card mt-2">
        <div class="title m-3 mb-0">
            <h3>
                Company Settings
            </h3>
        </div>

        <div class="container mb-3">
            <p class="text-muted p-1" *ngIf="text!=='View'">Update your company-wide settings</p>
            <div class="d-flex justify-content-center mb-3 text-danger" *ngIf="modelError">
                <p>{{modelError}}</p>
            </div>

            <ul class="nav nav-tabs mb-3" id="examTab" role="tablist">
                <li class="nav-item" role="presentation">
                    <button class="nav-link active bg-success text-white" id="tab0" data-bs-toggle="tab"
                        data-bs-target="#basicTab" type="button" role="tab">Instructions</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link " id="tab1" data-bs-toggle="tab" data-bs-target="#logoTab" type="button"
                        role="tab">Logo</button>
                </li>
            </ul>

            <div class="tab-content" id="tabContent">
                <form (ngSubmit)="saveCompanyInfo()">

                    <!-- Instructions Tab -->
                    <div class="tab-pane fade show active" id="basicTab" role="tabpanel">
                        <div class="form-group">
                            <label>Enter instructions you want to show to all candidates before all exams</label>

                            <quill-editor [(ngModel)]="companyInfo.instructionsHTML"
                                [ngModelOptions]="{ standalone: true }" placeholder="Type here..." class="w-100">
                            </quill-editor>
                        </div>

                        <div class="d-flex justify-content-end mt-3">
                            <button type="submit" class="btn btn-lg btn-success">Update</button>
                        </div>
                    </div>

                    <!-- Logo Tab -->
                    <div class="tab-pane fade" id="logoTab" role="tabpanel">
                        <div class="d-flex flex-column align-items-center">
                            <div class="mb-3">
                                <img #logoPix [src]="companyInfo?.logoURL" alt="Company Logo" class="img-thumbnail"
                                    style="max-width: 200px;">
                            </div>

                            <div class="mb-3">
                                <div class="mt-2" style="display: flex;align-content: left;justify-content: left;">
                                    <input type="file" class="cursorP" class="form-control" accept="image/*"
                                        (change)="onFileChange($event)">
                                    <span (click)="uploadLogo()" class="btn btn-success ml-4">Upload</span>
                                </div>
                            </div>
                        </div>
                    </div>

                </form>
            </div>


        </div>
    </div>
</div>